import axios from "axios";
import Errores from "@/utils/Errores";

export default {
  obtenerPostulaciones: async (runPostulante, componente) => {
    return await axios
      .get(
        API.POSTULACION +
          "postulaciones/enviadas?runPostulante=" +
          runPostulante
      )
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        Errores.switchErrors(error, componente, [
          {
            codigo: 404,
            mensaje: "El RUN consultado no ha postulado."
          }
        ]);
        return [];
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/ApiPostulacion.js